import { createStore, useStore } from './store';

export type ToastKind = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: number;
  kind: ToastKind;
  text: string;
  action?: { label: string; run: () => void };
  duration: number;
}

const toastStore = createStore<{ items: Toast[] }>({ items: [] });
let nextId = 1;

export function toast(text: string, kind: ToastKind = 'info', opts: { action?: Toast['action']; duration?: number } = {}): number {
  const id = nextId++;
  const duration = opts.duration ?? (kind === 'error' ? 7000 : 4000);
  toastStore.set((s) => ({ items: [...s.items.slice(-4), { id, kind, text, action: opts.action, duration }] }));
  if (duration > 0) setTimeout(() => dismissToast(id), duration);
  return id;
}

export function dismissToast(id: number): void {
  toastStore.set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
}

export function useToasts(): Toast[] {
  return useStore(toastStore, (s) => s.items);
}
